import { useEffect, useRef } from 'react';
import { usePostHog } from '@posthog/react';
import { useAuth } from '@/contexts/AuthContext';
import { profileService } from '@/services';

/**
 * Bridges Supabase Auth state to PostHog identity.
 * - On sign-in: identifies user and sets company group
 * - On sign-out: resets PostHog identity
 */
export function PostHogIdentifier() {
  const posthog = usePostHog();
  const { user } = useAuth();
  const identifiedUserRef = useRef<string | null>(null);

  useEffect(() => {
    if (!posthog) return;

    if (user && user.id !== identifiedUserRef.current) {
      posthog.identify(user.id, { email: user.email });
      identifiedUserRef.current = user.id;

      profileService.getCurrentProfile().then(({ data: profile }) => {
        if (profile?.company_id) {
          posthog.group('company', profile.company_id);
        }
      });
    } else if (!user && identifiedUserRef.current) {
      posthog.reset();
      identifiedUserRef.current = null;
    }
  }, [posthog, user]);

  return null;
}
